module.exports = __webpack_public_path__ + "static/media/akropolis.1a7e58c7.svg";